<template>
	<div class="receAddress layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="setClass(1)" v-if="showClass!=1" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i> {{showClass==1?'收货地址': showClass==2?'新建收货地址':'编辑收货地址'}}
			</div>
		</div>
		<div v-show="showClass==1">
			<button v-if="is_sub == 0" @click="setClass(2)" type="button" class="layui-btn zt_color" style="margin: 16px 0 16px 5%;">新建收货地址</button>
			<table class="layui-table" id="receAddress" style="width:90%;margin:0 5%;">
				<colgroup>
					<col width="100">
					<col width="150">
					<col>
					<col>
					<col>
				</colgroup>
				<thead>
					<tr>
						<th class="align_center">默认</th>
						<th class="align_center">姓名</th>
						<th class="align_center">电话</th>
						<th class="align_center">地址</th>
						<th class="align_center">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in datas" :key="i">
						<td class="align_center">
							<span v-if="item.is_default" class="zt_color txt_white blocks" style="width:55px;margin:0 auto;">默认</span>
						</td>
						<td class="align_center">{{item.name}}</td>
						<td class="align_center">{{item.mobile}}</td>
						<td class="align_center" style="width:40%;">{{item.province+ item.city + item.area + item.address}}</td>
						<td class="align_center">
							<button class="layui-btn layui-btn-warm layui-btn-sm" @click="setTheAddr(item)">默认</button>
							<button class="layui-btn layui-btn-normal layui-btn-sm" @click="editTheAddr(item)">编辑</button>
							<button class="layui-btn layui-btn-danger layui-btn-sm" @click="delTheAddr(item)">删除</button>
						</td>
					</tr>
					<tr v-if="datas.length == 0">
						<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="5">暂无数据</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div v-if="showClass==2">
			<form class="layui-form px16" id="form" action="" style="margin:30px 0px;">
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">姓名</label>
					<div class="layui-input-inline">
						<input type="text" name="names" maxlength="20" required lay-reqText="请输入姓名" lay-verify="required" placeholder="请输入姓名" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">电话</label>
					<div class="layui-input-inline">
						<input type="phone" name="phone" maxlength="11" required lay-reqText="请输入电话" lay-verify="phone" placeholder="请输入电话" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">地址</label>
					<div class="layui-input-inline">
						<select name="province" lay-verify="required" lay-reqText="请选择省份">
							<option value="">省份</option>
							<option v-for="(item,index) in provinceData" :data-i="index" :value="item.provinceName" :key="item.provinceCode">{{item.provinceName}}</option>
						</select>
					</div>
					<div class="layui-input-inline">
						<select name="city" lay-verify="required" lay-reqText="请选择城市">
							<option value="">城市</option>
							<option v-for="(item,index) in cityData" :data-i="index" :value="item.cityName" :key="item.cityCode">{{item.cityName}}</option>
						</select>
					</div>
					<div class="layui-input-inline">
						<select name="area" lay-verify="required" lay-reqText="请选择区域">
							<option value="">区域</option>
							<option v-for="(item,index) in areaData" :data-i="index" :value="item.areaName" :key="item.areaCode">{{item.areaName}}</option>
						</select>
					</div>
					<div class="layui-input-inline" style="min-width:300px;">
						<input type="text" name="addDetail" required lay-verify="required" maxlength="30" lay-reqText="请输入详细地址" placeholder="请输入详细地址" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">选择地址</label>
					<div class="layui-input-block" style="display: flex;position: relative;">
						<div id="baiduMap" style="width: 900px;height: 500px;"></div>
						<div style="position: absolute;top: 20px;left: 0px;z-index: 888;">
							<input type="text" id="suggestId" placeholder="搜索" class="layui-input" style="width: 300px;margin-left: 20px;">
							<div id="searchResultPanel" style="display: none;"></div>
						</div>
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">默认</label>
					<div class="layui-input-block">
						<input type="checkbox" name="switch" lay-skin="switch">
					</div>
				</div>
				<button type="button" class="layui-btn zt_color" lay-submit lay-filter="addAddress" style="width:155px;margin: 20px 0 0 110px;">保存</button>
			</form>
		</div>
		<!--弹出层-->
		<div class="layer" v-if='edit'></div>
		<div id="edit" style="display: none;">
			<form class="layui-form px16" action="" style="margin:30px 0px;" lay-filter="formTest">
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">姓名</label>
					<div class="layui-input-inline">
						<input type="text" v-model="editName" name="names" maxlength="20" required lay-reqText="请输入姓名" lay-verify="required" placeholder="请输入姓名" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">电话</label>
					<div class="layui-input-inline">
						<input type="phone" v-model="editPhone" name="phone" maxlength="11" required lay-reqText="请输入电话" lay-verify="phone" placeholder="请输入电话" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">地址</label>
					<div class="layui-input-inline">
						<select name="province" lay-verify="required" lay-reqText="请选择省份">
							<option value="">省份</option>
							<option v-for="(item,index) in provinceData" :value="item.provinceName" :key="item.provinceCode">{{item.provinceName}}</option>
						</select>
					</div>
					<div class="layui-input-inline">
						<select name="city" lay-verify="required" lay-reqText="请选择城市">
							<option value="">城市</option>
							<option v-for="(item,index) in cityData" :value="item.cityName" :key="item.cityCode">{{item.cityName}}</option>
						</select>
					</div>
					<div class="layui-input-inline">
						<select name="area" lay-verify="required" lay-reqText="请选择区域">
							<option value="">区域</option>
							<option v-for="(item,index) in areaData" :value="item.areaName" :key="item.areaCode">{{item.areaName}}</option>
						</select>
					</div>
					<div class="layui-input-inline" style="min-width:300px;">
						<input type="text" v-model="editAddr" name="addDetail" maxlength="30" required lay-verify="required" lay-reqText="请输入详细地址" placeholder="请输入详细地址" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20" style="cursor: pointer;color: blue;" @click="eidtMap">修改坐标</label>
					<div class="layui-input-block" style="display: flex;position: relative;">
						<div id="baiduMap2" style="width: 900px;height: 500px;"></div>
						<div style="position: absolute;top: 20px;left: 0px;z-index: 888;">
							<input type="text" id="suggestId2" placeholder="搜索" class="layui-input" style="width: 300px;margin-left: 20px;">
							<div id="searchResultPanel2" style="display: none;"></div>
						</div>
					</div>					
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">默认</label>
					<div class="layui-input-block">
						<input type="checkbox" name="switch" lay-skin="switch">
					</div>
				</div>
				<button type="button" class="layui-btn zt_color" lay-submit lay-filter="editAddress" style="width:155px;margin: 20px 0 0 110px;">保存</button>
			</form>
		</div>
	</div>
</template>

<script>
	import city from "@/utils/city.js";
	var map = '';
	var map2 = '';
	export default {
		name: 'receAddress',
		data() {
			return {
				is_sub: 1,
				showClass: 1,
				forms: '',
				province: 0,
				province2: 0,
				city: 0,
				city2: 0,
				area: 0,
				datas: [],
				provinceData: [],
				cityData: [],
				areaData: [],
				edit: false,
				editName: '',
				editPhone: '',
				editAddr: '',
				editDefault: '',
				mapAdd: '',
				cityInfo: {
					longitude: 116.404,
					latitude: 39.915,
				},
				lng: '',
				lat: ''
			}
		},
		created() {
			this.getData();

		},
		mounted() {
			let _this = this;
			layui.use(['form', 'layer', 'table'], () => {
				_this.forms = layui.form;
				let layer = layui.layer;
				let table = layui.table;
				_this.forms.on('submit(addAddress)', function(data) { //监听提交
					let is_default = 0;
					if(data.field.switch) {
						is_default = 1;
					}
					if(_this.lat == '' || _this.lng == '') {
						layer.msg('请在地图上选择收货地址', {
							icon: 2,
							anim: 6
						});
						return false;
					}
					api.addAddress({
						token: _this.getCookie('token'),
						name: data.field.names,
						mobile: data.field.phone,
						province: data.field.province,
						city: data.field.city,
						area: data.field.area,
						address: data.field.addDetail,
						is_default: is_default,
						lng: _this.lng,
						lat: _this.lat,
					}).then((res) => {
						if(res.code == 1) {
							layer.msg('添加成功', {
								icon: 1,
								anim: 5
							})
							_this.provinceData = [];
							_this.cityData = [];
							_this.areaData = [];
							_this.forms.render('select');
							document.getElementById("form").reset()
							_this.forms.render();
							_this.getData();
							_this.showClass = 1;
						}
					})
					return false;
				});
				_this.forms.on('select()', function(e) { //监听下拉框
					let index = e.elem.selectedIndex - 1;
					index = index < 0 ? 0 : index;
					if(e.elem.name == 'province') {
						_this.cityData = _this.provinceData[index].mallCityList;
						_this.areaData = [];
					} else if(e.elem.name == 'city') {
						_this.areaData = _this.cityData[index].mallAreaList;
					}
					_this.theLocation(e.value);
					setTimeout(function() {
						_this.forms.render('select');
					}, 100);
				});
			});
		},
		methods: {
			getData() {
				let _this = this;
				api.getAddressList({
					token: this.getCookie('token')
				}).then((res) => {
					_this.is_sub = _this.$store.state.is_sub || 0;
					_this.datas = res.data;
				})
			},
			setTheAddr(item) {
				let _this = this;
				api.setDefaultAddress({
					token: _this.getCookie('token'),
					id: item.id,
				}).then((res) => {
					if(res.code == 1) {
						_this.getData();
					}
				})
			},
			editTheAddr(item) {
				let _this = this;
				this.cityData = [];
				this.areaData = [];
				this.provinceData = city.city;
				this.edit = true;
				this.editName = item.name;
				this.editPhone = item.mobile;
				this.editAddr = item.address;
				for(let i = 0; i < this.provinceData.length; i++) {
					if(item.province == this.provinceData[i].provinceName) {
						this.cityData = this.provinceData[i].mallCityList;
						for(let j = 0; j < this.cityData.length; j++) {
							if(item.city == this.cityData[j].cityName) {
								this.areaData = this.cityData[j].mallAreaList;
								break
							}
						}
						break
					}
				}
				layui.use(['form', 'layer', 'table'], () => {
					var form = layui.form;
					setTimeout(() => {
						layer.open({
							title: '编辑',
							type: 1,
							zIndex: 999,
							content: $('#edit'),
							area: ['1200px', '600px'],
							shade: 0,
							success: function() {
								form.val("formTest", {
									"province": item.province,
									"city": item.city,
									"area": item.area,
									"switch": item.is_default,
								});
								form.render('select', 'formTest');
								setTimeout(() => {
									_this.lng = item.lng;
									_this.lat = item.lat;
									_this.createMap2(item.lng,item.lat);
								}, 500)
							},
							cancel: function(index, layero) {
								_this.edit = false
							}
						});
					}, 100)
					form.on('submit(editAddress)', function(data) { //监听提交
						let is_default = 0;
						if(data.field.switch) {
							is_default = 1;
						}
						if(_this.lat == '' || _this.lng == '') {
							layer.msg('请在地图上选择收货地址', {
								icon: 2,
								anim: 6
							});
							return false;
						}
						api.editAddress({
							token: _this.getCookie('token'),
							id: item.id,
							name: data.field.names,
							mobile: data.field.phone,
							province: data.field.province,
							city: data.field.city,
							area: data.field.area,
							address: data.field.addDetail,
							is_default: is_default,
							lng: _this.lng,
							lat: _this.lat,
						}).then((res) => {
							if(res.code == 1) {
								form.render();
								_this.getData();
								_this.edit = false;
								layer.closeAll();
								layer.msg('保存成功', {
									icon: 1,
									anim: 5
								})
							}
						})
						return false;
					});
					form.on('select()', function(e) { //监听下拉框
						let index = e.elem.selectedIndex - 1;
						console.log(e);
						index = index < 0 ? 0 : index;
						if(e.elem.name == 'province') {
							_this.cityData = _this.provinceData[index].mallCityList;
							_this.areaData = [];
						} else if(e.elem.name == 'city') {
							_this.areaData = _this.cityData[index].mallAreaList;
						}
						_this.theLocation2(e.value);
						setTimeout(function() {
							_this.forms.render('select');
						}, 100);
					});
				});
			},
			delTheAddr(item) {
				let _this = this;
				layui.use(['layer'], () => {
					let layer = layui.layer;
					layer.open({
						type: 0,
						content: '是否需确认删除该地址？',
						btn: ['确认', '取消'],
						btnAlign: 'c',
						resize: false,
						closeBtn: 0,
						skin: 'demo-class',
						yes: function(index, layero) {
							layer.closeAll();
							api.delAddress({
								token: _this.getCookie('token'),
								id: item.id,
							}).then((res) => {
								layer.msg('删除成功', {
									icon: 1,
									anim: 5
								})
								_this.getData();
							})
						},
						btn2: function(index, layero) {
							layer.closeAll();
						}
					});
				});
			},
			setClass(e) {
				this.showClass = e;
				if(e == 2) {
					let _this = this;
					this.cityData = [];
					this.areaData = [];
					this.provinceData = city.city;
					setTimeout(function() {
						_this.forms.render();
						_this.createMap();
					}, 500);

				}
			},
			createMap() {
				let _this = this;
				map = new BMap.Map("baiduMap", {
					enableMapClick: false
				});
				map.centerAndZoom('深圳', 12); // 创建点坐标,初始化地图,设置中心点坐标和地图级别
				map.addControl(new BMap.ScaleControl({
					anchor: BMAP_ANCHOR_BOTTOM_LEFT
				}));
				map.addControl(new BMap.NavigationControl({
					anchor: BMAP_ANCHOR_BOTTOM_RIGHT
				}));
				map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
				map.enableInertialDragging(); //两秒后开启惯性拖拽
				map.addEventListener("click", function(e) { //单击地图事件
					_this.lng = e.point.lng;
					_this.lat = e.point.lat;
					let point = new BMap.Point(e.point.lng, e.point.lat);
					let marker = new BMap.Marker(point);
					map.clearOverlays();
					map.addOverlay(marker);
				});

				var ac = new BMap.Autocomplete({
					"input": "suggestId",
					"location": map
				});
				ac.addEventListener("onhighlight", function(e) { //鼠标放在下拉列表上的事件
					var str = "";
					var _value = e.fromitem.value;
					var value = "";
					if(e.fromitem.index > -1) {
						value = _value.province + _value.city + _value.district + _value.street + _value.business;
					}
					str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;
					value = "";
					if(e.toitem.index > -1) {
						_value = e.toitem.value;
						value = _value.province + _value.city + _value.district + _value.street + _value.business;
					}
					str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
					document.getElementById("searchResultPanel").innerHTML = str;
				});

				var myValue;
				ac.addEventListener("onconfirm", function(e) { //鼠标点击下拉列表后的事件
					var _value = e.item.value;
					myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
					document.getElementById("searchResultPanel").innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
					setPlace();
				});

				function setPlace() {
					map.clearOverlays(); //清除地图上所有覆盖物
					function myFun() {
						var pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
						_this.lng = pp.lng;
						_this.lat = pp.lat;
						map.centerAndZoom(pp, 18);
						map.addOverlay(new BMap.Marker(pp)); //添加标注
					}
					var local = new BMap.LocalSearch(map, { //智能搜索
						onSearchComplete: myFun
					});
					local.search(myValue);
				}
			},
			theLocation(val) {
				map.centerAndZoom(val, 11);
			},
			createMap2(lng,lat) {
				let _this = this;
				map2 = new BMap.Map("baiduMap2", {
					enableMapClick: false
				});
				map2.centerAndZoom(new BMap.Point(lng, lat), 14); // 创建点坐标,初始化地图,设置中心点坐标和地图级别
				map2.addControl(new BMap.ScaleControl({
					anchor: BMAP_ANCHOR_BOTTOM_LEFT
				}));
				map2.addControl(new BMap.NavigationControl({
					anchor: BMAP_ANCHOR_BOTTOM_RIGHT
				}));
				map2.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
				map2.enableInertialDragging(); //两秒后开启惯性拖拽
				map2.addOverlay(new BMap.Marker(new BMap.Point(lng, lat)));
				var ac = new BMap.Autocomplete({
					"input": "suggestId2",
					"location": map2
				});
				ac.addEventListener("onhighlight", function(e) { //鼠标放在下拉列表上的事件
					var str = "";
					var _value = e.fromitem.value;
					var value = "";
					if(e.fromitem.index > -1) {
						value = _value.province + _value.city + _value.district + _value.street + _value.business;
					}
					str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;
					value = "";
					if(e.toitem.index > -1) {
						_value = e.toitem.value;
						value = _value.province + _value.city + _value.district + _value.street + _value.business;
					}
					str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
					document.getElementById("searchResultPanel2").innerHTML = str;
				});

				var myValue;
				ac.addEventListener("onconfirm", function(e) { //鼠标点击下拉列表后的事件
					var _value = e.item.value;
					myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
					document.getElementById("searchResultPanel2").innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
					setPlace2();
				});

				function setPlace2() {
					map2.clearOverlays(); //清除地图上所有覆盖物
					function myFun2() {
						var pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
						_this.lng = pp.lng;
						_this.lat = pp.lat;
						map2.centerAndZoom(pp, 18);
						map2.addOverlay(new BMap.Marker(pp)); //添加标注
					}
					var local = new BMap.LocalSearch(map2, { //智能搜索
						onSearchComplete: myFun2
					});
					local.search(myValue);
				}
			},
			eidtMap() {
				let _this = this;
				map2.addEventListener("click", function(e) { //单击地图事件
					_this.lng = e.point.lng;
					_this.lat = e.point.lat;
					let point = new BMap.Point(e.point.lng, e.point.lat);
					let marker = new BMap.Marker(point);
					map2.clearOverlays();
					map2.addOverlay(marker);
				});
			},
			theLocation2(val) {
				map2.centerAndZoom(val, 11);
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.layui-header {
		z-index: 0;
	}
	
	.layer {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 998;
	}
</style>


// WEBPACK FOOTER //
// src/components/receAddress.vue